import React from 'react'
import ArchitecturalModeling from './ArchitecturalModeling'
import CharacterDrawingProcess from './CharacterDrawingProcess'
import CharacterModeling from './CharacterModeling'
import FashionModeling from './FashionModeling'
import FoodModeling from './FoodModeling'
import GameModeling from './GameModeling'
import HomeGoods from './HomeGoods'
import IndustrialModeling from './IndustrialModeling'
import MailBox from './MailBox'
import MultiItemSlider from './MultiItemSlider'
import PhotographyReplacement from './PhotographyReplacement'
import PhotoRealistic from './PhotoRealistic'
import ProductModeling from './ProductModeling'
import SketchfabChair from './SketchfabChair'
import ThreeDBanner from './ThreeDBanner'

const ThreeDModel = () => {
	document.title = "Paracosma | 3D Model"
  	return (
    	<>

			<div className="main-body content">
				<ThreeDBanner />
				<PhotoRealistic />
				<HomeGoods />
				<MultiItemSlider />
				<PhotographyReplacement />
				<SketchfabChair />
				<ProductModeling />
				<MailBox />
				<FashionModeling />
				<FoodModeling />
				<IndustrialModeling />
				<ArchitecturalModeling />
				<GameModeling />
				<CharacterModeling />
				<CharacterDrawingProcess />
			</div>
		</>
  	)
}

export default ThreeDModel
